angular.module('app')
    .controller('DocArchiveCtrl', function ($scope) {

        $scope.initialize = function () {

        }

        $scope.start = function () {

        }


        $scope.onPressSearch = function (value) {
            $scope.filter = value;
        }

        $scope.restIsPending = function (value) {
            $scope.loaderRestCalling = value;
        }

    })